var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-simple-suggest",
    {
      ref: "suggestComponent",
      attrs: {
        pattern: "\\w+",
        list: _vm.getList,
        "max-suggestions": 10,
        "min-length": 1,
        debounce: 200,
        "filter-by-query": false,
        "prevent-submit": true,
        controls: {
          selectionUp: [38, 33],
          selectionDown: [40, 34],
          select: [13, 36],
          hideList: [27, 35]
        },
        mode: _vm.mode,
        "nullable-select": true,
        placeholder: "Search Customer",
        "value-attribute": "email",
        "display-attribute": "email"
      },
      on: { select: _vm.onSuggestSelect },
      scopedSlots: _vm._u(
        [
          {
            key: "misc-item-above",
            fn: function(ref) {
              var suggestions = ref.suggestions
              var query = ref.query
              return [
                _c("div", { staticClass: "misc-item" }, [
                  _c("span", [
                    _vm._v("You're searching for '" + _vm._s(query) + "'.")
                  ])
                ]),
                _vm._v(" "),
                suggestions.length > 0
                  ? [
                      _c("div", { staticClass: "misc-item" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(suggestions.length) +
                              " suggestions are shown..."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr")
                    ]
                  : !_vm.loading
                  ? _c("div", { staticClass: "misc-item" }, [
                      _c("span", [_vm._v("No results")])
                    ])
                  : _vm._e()
              ]
            }
          },
          {
            key: "suggestion-item",
            fn: function(scope) {
              return _c(
                "div",
                { attrs: { title: scope.suggestion.description } },
                [
                  _c("div", { staticClass: "text" }, [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.boldenSuggestion(scope))
                      }
                    })
                  ])
                ]
              )
            }
          },
          {
            key: "misc-item-below",
            fn: function(ref) {
              var suggestions = ref.suggestions
              return _vm.loading
                ? _c("div", { staticClass: "misc-item" }, [
                    _c("span", [_vm._v("Loading...")])
                  ])
                : _vm._e()
            }
          }
        ],
        null,
        true
      ),
      model: {
        value: _vm.model,
        callback: function($$v) {
          _vm.model = $$v
        },
        expression: "model"
      }
    },
    [
      _c("div", { staticClass: "g" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.model,
              expression: "model"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.model },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.model = $event.target.value
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }